import { Loader2 } from "lucide-react";

const PanelHeader = ({ isLive }) => (
    <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
        <div className="flex items-center gap-2">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-blaze">
                OUT · SPCLIVE 2.5
            </span>
        </div>
        <div className="flex items-center gap-3">
            {isLive && (
                <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-blaze">
                    <span className="w-1.5 h-1.5 bg-blaze rounded-full live-pulse" />
                    Broadcasting
                </span>
            )}
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                720p · 30 FPS
            </span>
        </div>
    </div>
);

const AwaitingOverlay = () => (
    <div className="absolute inset-0 flex flex-col items-center justify-center text-white/30 gap-4">
        <div className="font-display font-bold uppercase text-4xl text-white/10 tracking-tight">
            Awaiting Signal
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
            Press START to engage
        </div>
    </div>
);

const FirstFrameOverlay = () => (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
        <Loader2 className="w-8 h-8 text-blaze animate-spin" />
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-blaze">
            Waiting for first frame...
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-white/30">
            SPCLIVE is painting your stream
        </div>
    </div>
);

const ConnectingOverlay = ({ statusDetail }) => (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
        <Loader2 className="w-10 h-10 text-electric animate-spin" />
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-electric">
            {statusDetail || "Negotiating WebRTC..."}
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-white/30 max-w-md text-center px-6">
            First connection can take 10–25s. If this hangs, check your network allows WebRTC (UDP) and your browser is Chrome/Firefox/Safari.
        </div>
    </div>
);

const CornerMarks = () => (
    <>
        <div className="absolute top-2 left-2 w-4 h-4 border-l border-t border-white/30" />
        <div className="absolute top-2 right-2 w-4 h-4 border-r border-t border-white/30" />
        <div className="absolute bottom-2 left-2 w-4 h-4 border-l border-b border-white/30" />
        <div className="absolute bottom-2 right-2 w-4 h-4 border-r border-b border-white/30" />
    </>
);

export const OutputPanel = ({ remoteVideoRef, isLive, isConnecting, hasOutput, statusDetail, orientation }) => (
    <div className="border border-white/10 bg-surface">
        <PanelHeader isLive={isLive} />
        <div
            className={`aspect-video bg-black relative overflow-hidden ${isLive ? "scan-line" : ""}`}
            data-testid="output-panel"
        >
            <video
                ref={remoteVideoRef}
                autoPlay
                playsInline
                className={`w-full h-full ${orientation === "portrait" ? "object-contain" : "object-cover"}`}
                data-testid="remote-video"
            />
            {!hasOutput && !isConnecting && !isLive && <AwaitingOverlay />}
            {!hasOutput && isLive && <FirstFrameOverlay />}
            {isConnecting && <ConnectingOverlay statusDetail={statusDetail} />}
            <CornerMarks />
        </div>
    </div>
);
